import { Component } from '@angular/core';

@Component({
  standalone: true,
  selector: 'curbnturf-empty-bubble',
  templateUrl: './empty-bubble.component.html',
  styleUrls: ['./empty-bubble.component.scss'],
  imports: [],
})
export class EmptyBubbleComponent {}
